<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> person </v-icon>
      <span :class="ui.textHeadline"> User </span>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        User profile management, support, statistics, access, preferences.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <v-btn :color="ui.btnColorError" flat dark
        v-if="!this.getUser.basic.act && this.getUser.basic.title !== ''">
          <v-icon left>
            person
          </v-icon>
          User
        </v-btn>
        <v-spacer/>
        <UserSetup v-if="this.getUser.basic.title === ''"/>
        <v-btn :color="ui.btnColor" flat dark :to="'/userdash'"
          v-if="this.getUser.basic.title !== ''">
          <v-icon left>
            apps
          </v-icon>
          Select
        </v-btn>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import UserSetup from "@/user/user/components/UserSetup";

export default {
  mixins: [apptheme, adminFunctions],
  components: {
    UserSetup
  },
  data() {
    return {
      valid: true
    };
  }
};
</script>
